import { render } from "./PanelGroup.vue?vue&type=template&id=d90b74d4&scoped=true&ts=true"
import script from "./PanelGroup.vue?vue&type=script&lang=ts"
export * from "./PanelGroup.vue?vue&type=script&lang=ts"

import "./PanelGroup.vue?vue&type=style&index=0&id=d90b74d4&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d90b74d4"]])

export default __exports__